import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  IOS_URL,
  ANDROID_URL,
  appStoreBadgeUrl,
  appStoreBadgeAlt,
  googlePlayBadgeUrl,
  googlePlayBadgeAlt,
} from '../constants/storeLinks';

/**
 * @param {string}  [className]         Extra classes for the wrapper div (e.g. justify-center md:justify-start)
 * @param {'ios'|'android'|null} [detectedPlatform]  Highlights the matching badge (Download page only)
 */
export default function BadgeRow({ className = '', detectedPlatform }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const iosHighlight   = detectedPlatform === 'ios'     ? 'ring-2 ring-[#13C5C5] ring-offset-2 rounded-lg scale-105' : 'hover:opacity-80';
  const droidHighlight = detectedPlatform === 'android' ? 'ring-2 ring-[#13C5C5] ring-offset-2 rounded-lg scale-105' : 'hover:opacity-80';

  return (
    <div className={`flex flex-row flex-wrap items-center gap-3 ${className}`}>
      <a
        href={IOS_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={appStoreBadgeAlt(lang)}
        className={`inline-block transition-all ${iosHighlight}`}
      >
        <img
          src={appStoreBadgeUrl(lang)}
          alt={appStoreBadgeAlt(lang)}
          style={{ height: 40, width: 'auto', display: 'block' }}
          loading="lazy"
        />
      </a>
      <a
        href={ANDROID_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={googlePlayBadgeAlt(lang)}
        className={`inline-block transition-all ${droidHighlight}`}
      >
        <img
          src={googlePlayBadgeUrl(lang)}
          alt={googlePlayBadgeAlt(lang)}
          style={{ height: 58, width: 'auto', display: 'block' }}
          loading="lazy"
        />
      </a>
    </div>
  );
}
